import { safeGetItem } from '/Foundation/React/code/Utilities/LocalStorage';

export const getBrand = () => {
  if (window._THULEDATA !== null) {
    return window._THULEDATA.SitecoreSiteName;
  } else if (window._EXTRANETDATA !== null) {
    return window._EXTRANETDATA.SitecoreSiteName;
  }

  return '';
};

export const GetDeviceParameterData = () => {
  if (window.innerWidth <= 767) return 'Mobile';

  if (window.innerWidth <= 991) return 'Tablet';

  return 'Desktop';
};

export const analyticsForAdd = (action) => {
  const { product, quantity, currencyCode } = action.payload;

  const products = [{ ...lineToAnalyticsProduct(product), quantity }];
  const analytics = {
    event: 'EEaddToCart_cart',
    ecommerce: {
      currencyCode,
      add: {
        products,
      },
    },
  };
  return analytics;
};

export const analyticsForRemove = (action) => {
  const { product, quantity, currencyCode } = action.payload;

  const products = [{ ...lineToAnalyticsProduct(product), quantity }];
  const analytics = {
    event: 'EEremoveFromCart',
    ecommerce: {
      currencyCode,
      remove: {
        products,
      },
    },
  };
  return analytics;
};

const lineToAnalyticsProduct = (line) => {
  const analyticsData = safeGetItem('analytics.categories');
  let analyticsEntry;
  if (analyticsData) analyticsEntry = analyticsData[line.key];
  return {
    id: line.productId || '',
    name: line.webtitle1 || '',
    price: line.originalUnitPrice || '',
    metric2: line.discountedUnitPrice != null ? line.discountedUnitPrice : '',
    brand: getBrand(),
    category: analyticsEntry?.Categoryanalytics || '',
    variant: '',
    quantity: line.quantity || '',
  };
};

export const getAnalyticsDataForCartProducts = async (cart) => {
  if (!cart?.lineItems?.length) return;
  const analyticsData = await resolveAnalyticsData(cart.lineItems.map((line) => line.key).filter(Boolean));
  setAdobeDataLayerProducts(cart.lineItems, analyticsData);
};

export const setAdobeDataLayerProductsFromOrder = async (order) => {
  if (!order?.lines?.length) return;
  const analyticsData = await resolveAnalyticsData(order.lines.map((line) => line.key).filter(Boolean));
  setAdobeDataLayerProducts(order.lines, analyticsData);
};

const setAdobeDataLayerProducts = (lines, analyticsData) => {
  if (!window.adobeDataLayer) return;

  const analyticsById = {};
  analyticsData.forEach((data) => {
    if (data.ProductId) analyticsById[data.ProductId] = data;
  });

  window.adobeDataLayer.products = lines.map((line) => {
    const data = analyticsById[line.key] ?? {};
    const saleUnitPrice = line.unitDiscountedPrice ?? line.discountedUnitPrice;
    const originalUnitPrice = line.unitPrice ?? line.originalUnitPrice ?? 0;
    return {
      id: line.key,
      name: line.webtitle1,
      colour: data.ColorSpecification,
      category: data.Categoryanalytics,
      subcategory: data.Subcategoryanalytics,
      over_category: data.Overcategoryanalytics,
      price: `${saleUnitPrice != null ? saleUnitPrice : originalUnitPrice}`,
      original_price: `${originalUnitPrice}`,
      quantity: line.quantity,
      pricetotal: `${line.discountedPrice != null ? line.discountedPrice : line.price}`,
    };
  });
};

const resolveAnalyticsData = async (productIds) => {
  if (!productIds.length) return [];

  const cached = getAnalyticsDataFromLocalStorage(productIds);
  if (cached?.length) return cached;

  try {
    const response = await fetch('/api/sitecore/adobeanalytics/categories', {
      method: 'POST',
      body: JSON.stringify(productIds),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    });
    const analyticsData = await response.json();
    if (analyticsData?.length) {
      saveAnalyticsDataToLocalStorage(analyticsData);
      return analyticsData;
    }
  } catch (error) {
    console.error('Error fetching analytics data:', error);
  }

  return [];
};

const saveAnalyticsDataToLocalStorage = (analyticsData) => {
  try {
    const localStorageData = {};
    analyticsData.forEach((item) => {
      if (item.ProductId) {
        localStorageData[item.ProductId] = item;
      }
    });
    localStorage.setItem('analytics.categories', JSON.stringify(localStorageData));
  } catch (error) {
    console.error('Error saving analytics data to localStorage:', error);
  }
};

const getAnalyticsDataFromLocalStorage = (productIds) => {
  try {
    const analyticsDataFromLocalStorage = safeGetItem('analytics.categories') ?? {};
    const result = [];

    // Check if all requested product IDs are in the cache
    for (const id of productIds) {
      if (analyticsDataFromLocalStorage[id]) {
        result.push(analyticsDataFromLocalStorage[id]);
      }
    }

    // If we found all items in cache, return them
    if (result.length === productIds.length) {
      return result;
    }

    // Otherwise return null to indicate cache miss
    return null;
  } catch (error) {
    console.error('Error retrieving analytics data from localStorage:', error);
    return null;
  }
};
